import React from 'react';
import { motion } from 'framer-motion';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Log error to your monitoring service
        console.error('Error caught by boundary:', error, errorInfo);

        // In production, send to error tracking service
        // if (process.env.NODE_ENV === 'production') {
        //   Sentry.captureException(error);
        // }
    }

    render() {
        if (this.state.hasError) {
            return (
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="min-h-screen flex items-center justify-center bg-gray-950 p-4"
                >
                    <div className="max-w-md w-full text-center">
                        <div className="mb-8">
                            <div className="text-6xl mb-4">⚠️</div>
                            <h1 className="text-3xl font-semibold text-white mb-2">
                                Oops! Something went wrong
                            </h1>
                            <p className="text-gray-400">
                                We're sorry for the inconvenience. Please try refreshing the page.
                            </p>
                        </div>

                        <div className="space-y-3">
                            <button
                                onClick={() => window.location.reload()}
                                className="w-full px-6 py-3 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-lg font-semibold hover:from-purple-700 hover:to-purple-800 transition-all"
                            >
                                Reload Page
                            </button>

                            <button
                                onClick={() => window.location.href = '/'}
                                className="w-full px-6 py-3 bg-gray-800 text-white rounded-lg font-semibold hover:bg-gray-700 transition-all"
                            >
                                Go to Home
                            </button>
                        </div>

                        {process.env.REACT_APP_ENV === 'staging' && this.state.error && (
                            <div className="mt-6 p-4 bg-red-900/20 border border-red-500/50 rounded-lg text-left">
                                <p className="text-red-400 text-sm font-mono">
                                    {this.state.error.toString()}
                                </p>
                            </div>
                        )}
                    </div>
                </motion.div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;